const LAST_CHANGES_FILTERS = {
    LAST_DAY: 1,
    LAST_7_DAYS: 7,
    LAST_30_DAYS: 30
};

const LAST_CHANGES_OPTIONS = [
    { title: 'Last 24 hours', value: LAST_CHANGES_FILTERS.LAST_DAY },
    { title: 'Last 7 days', value: LAST_CHANGES_FILTERS.LAST_7_DAYS },
    { title: 'Last 30 days', value: LAST_CHANGES_FILTERS.LAST_30_DAYS }
];

export { LAST_CHANGES_OPTIONS, LAST_CHANGES_FILTERS };
